import CheckmarkFilled from '@shared/assets/icons/checkmark/filled.svg';
import { Button } from '@shared/components/Button';
import { View } from '@shared/components/View';
import { API } from '@shared/types/api';
import { getTestId } from '@shared/util/getTestId';
import { MBReaction, reactions } from './types';
import classNames from './ReactionPicker.module.css';

export interface ReactionPickerProps {
  // Callback for when pressing a reaction
  onToggleReaction: (reaction: API.ReactionType, add: boolean) => void;

  // List of selected reaction types. Eg the reactions the user has already reacted with
  selected: API.ReactionType[];

  testID?: string;
}

/*
    This component lets the user pick a reaction. This is shown in a tooltip
    form when a reaction button is pressed.
*/
export function ReactionPicker({ onToggleReaction, selected, testID }: ReactionPickerProps) {
  return (
    <View className={classNames.reactionPicker} testID={testID}>
      {reactions.map(reaction => (
        <ReactionPickerItem
          key={reaction.type}
          selected={selected}
          reaction={reaction}
          onToggleReaction={onToggleReaction}
        />
      ))}
    </View>
  );
}

interface ReactionPickerItemProps {
  onToggleReaction: (reaction: API.ReactionType, add: boolean) => void;
  selected: API.ReactionType[];
  reaction: MBReaction;
}

function ReactionPickerItem({ reaction, onToggleReaction, selected }: ReactionPickerItemProps) {
  const isSelected = selected.includes(reaction.type);
  const onClick = () => onToggleReaction(reaction.type, !isSelected);
  const testID = getTestId('reaction-picker-item', reaction.emoji);

  return (
    <Button variant="ghost" onClick={onClick} testID={testID} className={classNames.item}>
      {reaction.emoji}
      {isSelected && (
        <div className={classNames.selectedIcon}>
          <CheckmarkFilled />
        </div>
      )}
    </Button>
  );
}
